import { FC } from "react";
import { SearchForm } from "./components/SearchForm";
import SearchMobileLayout from "./layouts/Search.mobile";
import SearchWebLayout from "./layouts/Search.web";
import { FormProps } from "antd";
import { useTranslation } from "react-i18next";
import { SearchFormInputs } from "../../constants";
import { JourneyChip } from "..";
import Carrier from "@Components/Carrier/Carrier";

const MainSearch: FC<{initialValues?:SearchFormInputs} & FormProps> = ({initialValues, ...props}) => {
  return (
    <SearchForm
      render={({ values: { journeyType }, errorFields }) => (
        <SearchWebLayout values={{ journeyType }} errorFields={errorFields} />
      )}
      initialValues={initialValues}
      {...props} 
    />
  );
};

const MobileSearch: FC<{initialValues?:SearchFormInputs} & FormProps> = ({initialValues,onFinish, ...props}) => {
  return (
    <SearchForm
      render={({ values: { journeyType }, errorFields }) => <SearchMobileLayout values={{ journeyType }} errorFields={errorFields} />}
      initialValues={initialValues}
      onFinish={onFinish}
      {...props}
    />
  );
};

const SecondarySearch: FC<{ initialValues:SearchFormInputs } & FormProps> = ({ initialValues, onFinish, ...props }) => {
  const { t } = useTranslation();

  return Carrier({
    label: t("Flights.search.editSearch"),
    renderTrigger: ({ open }) => (
      <div className="cursor-pointer rounded-lg border border-border-default p-3" onClick={open}>
        <JourneyChip searchObject={initialValues} />
      </div>
    ),
    renderSheet: ({ close }) => (
      <div className="overflow-y-auto">
        <MobileSearch
          initialValues={initialValues}
          onFinish={(values) => {
            close();
            onFinish?.(values);
          }}
          {...props}
        />
      </div>
    ),
  });
};

export { MainSearch, SecondarySearch, MobileSearch };
 